import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import bondService from "./bondService";

export const getAllBonds = createAsyncThunk(
  "bonds/getAll",
  async (data: any, thunkAPI: any) => {
    try {
      const response = await bondService.getAllBonds(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const addBond = createAsyncThunk(
  "bonds/add",
  async (data: any, thunkAPI: any) => {
    try {
      const response = await bondService.addBond(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const editBond = createAsyncThunk(
  "bonds/edit",
  async (data: any, thunkAPI: any) => {
    try {
      const response = await bondService.editBond(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  bonds: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
};

export const bondSlice = createSlice({
  name: "bond",
  initialState,
  reducers: {
    resetState: (state) => initialState,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllBonds.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllBonds.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.bonds = action.payload;
      })
      .addCase(getAllBonds.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(addBond.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addBond.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(addBond.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(editBond.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editBond.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(editBond.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      });
  },
});

export const { resetState } = bondSlice.actions;
export default bondSlice.reducer;
